import { useContext } from 'react'

// CTX
import { NavigationDispatchContext } from 'src/store/navigation/Store'
import { SaveDispatchContext } from 'src/store/save/Store'
import { MapDispatchContext } from 'src/store/map/Store'
import { InventoryDataContext, InventoryDispatchContext } from 'src/store/inventory/Store'
import { StatsDispatchContext } from 'src/store/stats/Store'
import { ItemDataContext } from 'src/store/items/Store'

// actions
import { newGame, restartGame } from 'src/store/save/actions'
import { setSwitch, setSwitches } from 'src/store/navigation/actions'
import { resetMap } from 'src/store/map/actions'
import { removeAllEquipment, resetQuantity } from 'src/store/inventory/actions'
import { resetPlayerStats, setEquippedStats } from 'src/store/stats/actions'


const useStartGame = () => {
  const { dispatchNavigation } = useContext(NavigationDispatchContext)
  const { dispatchSave } = useContext(SaveDispatchContext)
  const { dispatchMap } = useContext(MapDispatchContext)
  const { dispatchInventory } = useContext(InventoryDispatchContext)
  const { dispatchStats } = useContext(StatsDispatchContext)

  // static api data
  const { items } = useContext(ItemDataContext)

  // stateful data
  const { inventory } = useContext(InventoryDataContext)

  const startGame = () => {
    setSwitch(dispatchNavigation, 'event_open', false)
    resetPlayerStats(dispatchStats)
    newGame(dispatchSave)
    resetMap(dispatchMap)
    resetQuantity(dispatchInventory, 'bag')
    removeAllEquipment(dispatchInventory)
    resetQuantity(dispatchInventory, 'loot')
    setEquippedStats(dispatchStats, items, inventory)
    setSwitches(dispatchNavigation, [
      { event_open: true },
      { combat_open: false },
      { game_over: false }
    ])
  }

  const startOver = () => {
    setSwitch(dispatchNavigation, 'event_open', false)
    resetPlayerStats(dispatchStats)
    restartGame(dispatchSave)
    resetMap(dispatchMap)
    resetQuantity(dispatchInventory, 'bag')
    removeAllEquipment(dispatchInventory)
    resetQuantity(dispatchInventory, 'loot')
    setEquippedStats(dispatchStats, items, inventory)
    setSwitches(dispatchNavigation, [
      { event_open: true },
      { combat_open: false },
      { game_over: false }
    ])
  }

  return { startGame, startOver }
}

export default useStartGame
